var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  fill: "#2D91FF",
  r: 13.333
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.354 11.841a1.167 1.167 0 0 1 1.65 1.651l-8.179 8.179a1.167 1.167 0 0 1-1.65 0l-4.668-4.667a1.167 1.167 0 0 1 1.651-1.65L14 19.195l7.354-7.354Z",
  fill: "#fff"
})));
export default SvgImgCheckCircle;